/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect, useMemo, useState } from 'react';

import HomeAlerts from 'pages/homeAlerts';

import { useSelector } from 'react-redux';
import LabelHome from './labelHome';
import MobileHome from './mobileHome';
// import LabelAdminHome from 'modules/labelPrinting/pages/admin/home';
import LabelAdminHome from 'modules/labelPrinting/pages/catalog/products';

function HomeRender() {
  const user = useSelector((state) => state.user);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

  const isAdminLabel = useMemo(() => {
    if (!user?.profile) return false;
    return Boolean(
      user?.profile[0]?.find((profile) =>
        ['admin_label'].includes(profile.name)
      )
    );
  }, [user?.profile]);

  const isLabelProfile = useMemo(() => {
    if (!user?.profile) return false;
    return Boolean(
      user?.profile[0]?.find((profile) =>
        ['manager_label', 'label'].includes(profile.name)
      )
    );
  }, [user?.profile]);

  const isAdminRestaurant = useMemo(() => {
    if (!user?.profile) return false;
    return Boolean(
      user?.profile[0]?.find((profile) =>
        ['restaurants', 'manager'].includes(profile.name)
      )
    );
  }, [user?.profile]);


  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 1000);
    }

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isAdminLabel) return <LabelAdminHome />;
  if (isLabelProfile) return <LabelHome />;

  return <>{isMobile && isAdminRestaurant ? <HomeAlerts /> : isMobile ? <MobileHome /> : <HomeAlerts />}</>;
}

export default HomeRender;
